/**
 * AMBIENTE DEMO
 * ─────────────────────────────────────────────────────────────
 * true  → ambiente demo: solo se muestra la unidad de Integración Procesos
 *         Clínicos, el catálogo de unidades (getbuilding) se toma del servicio
 *         de pruebas y (en la Agenda) el login usa la colección userstest.
 * false → producción (unidades productivas y colección users).
 *
 * IMPORTANTE: regresar a false antes de compilar y desplegar producción.
 */
export const MODO_DEMO = false

/** Building_Id de la única unidad visible en el ambiente demo */
export const UNIDAD_DEMO = 'Hospital-MAC-Integración Procesos Clínicos'
